import { render, staticRenderFns } from "./Table.Type.vue?vue&type=template&id=419478f4&"
import script from "./Table.Type.vue?vue&type=script&lang=js&"
export * from "./Table.Type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports